import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';

import styles from './style.module.less';

const TrialPlanName = ({ isTrialExpired = false }) => {
  if (isTrialExpired) {
    return (
      <>
        <Text className={styles.strike} textType={TextType.H4} value={messages.freeTrialText} />
        <div className={classnames(styles.red, styles.small)}>
          <FormattedMessage {...messages.expired} />
        </div>
      </>
    );
  }

  return <Text textType={TextType.H4} value={messages.freeTrialText} />;
};

TrialPlanName.propTypes = {
  isTrialExpired: PropTypes.bool,
};

export default TrialPlanName;
